<template>
  <Div class="add_construction">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck ref="popupCheck" v-if="popup == 'check'" :text="successText" :enterType="postLoading"
          @go="popupAction" @cancel="poupupEnter"></PopupCheck>
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="contain_white notice_block">
      <div class="form_input flex">
        <label> 申請日期 </label>
        <div>{{ this.$moment().format("YYYY-MM-DD") }}</div>
      </div>
      <template v-if="!type || !type.includes('enterprise')">
        <div class="form_input flex">
          <label> 施工單編號 </label>
          <div>{{ this.formInput.form_id }}</div>
        </div>
        <div class="form_input flex">
          <label>
            工程編號/名稱
            <span class="must">*</span>
          </label>
          <div class="width_220">
            <el-select value-key="id" v-model="formInput.name" placeholder="請選擇" @change="handlerID">
              <el-option v-for="item in options.application" :key="item.value" :label="item.name"
                :value="item"></el-option>
            </el-select>
          </div>
        </div>
      </template>
      <div class="form_input flex" v-if="type && type.includes('enterprise')">
        <label>
          承辦人員
          <span class="must">*</span>
        </label>
        <div>
          <el-select v-model="formInput.employee_id" filterable placeholder="請選擇">
            <el-option v-for="item in options.development_employee" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="form_input flex" v-if="type && type.includes('enterprise')">
        <label>
          原事業單位名稱
          <span class="must">*</span>
        </label>
        <div class="width_220">
          <input type="text" class="input_primary" v-model="formInput.vendor_chinese" />
        </div>
      </div>

      <div class="form_input flex">
        <label>
          作業類別
          <span class="must">*</span>
        </label>
        <div class="width_220">
          <!-- <div>{{ formInput.type }}</div> -->
          <el-select v-model="formInput.type" placeholder="請選擇" :disabled="!formInput.vendor_chinese">
            <el-option v-for="item in options.type" :key="item.value" :label="item.name"
              :value="item.value"></el-option>
          </el-select>

          <!--選取是否緊急-->
          <!-- <div class="urgent">
            <el-checkbox v-model="formInput.urgent">{{
              options.urgent.name
            }}</el-checkbox>
          </div> -->
          <!-- <div class="mark mark_bg" v-if="formInput.type">
            {{ labelTransfrom({ key: "type", value: formInput.type }) }}
          </div> -->
        </div>
      </div>
      <div class="form_input flex" v-if="formInput.type && formInput.type === '特殊作業'">
        <label> 特殊作業項目<span class="must">*</span> </label>
        <div class="special_option">
          <el-checkbox-group value-key="op_id" v-model="formInput.op_id">
            <el-checkbox :label="item.op_id" v-for="(item, index) in options.special" :key="index">{{ item.op_name
              }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          施工日期
          <span class="must">*</span>
        </label>
        <div class="time_range flex">
          <el-date-picker v-model="formInput.date" type="date" :disabled="!formInput.type"
            :picker-options="pickerOptions" value-format="yyyy-MM-dd" placeholder="Day" @change="handlerClear"
            popper-class="picker-date"></el-date-picker>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          施工時間
          <span class="must">*</span>
        </label>
        <div class="time_range flex">
          <el-time-select placeholder="start-time" v-model="formInput.start_time" :disabled="!formInput.date"
            :picker-options="{
      start: '00:00',
      step: '00:15',
      end: '23:15',
    }">
          </el-time-select>
          <div>
            <i class="el-icon-caret-right"></i>
          </div>
          <el-time-select placeholder="end-time" :disabled="!formInput.date || !formInput.start_time"
            v-model="formInput.end_time" :picker-options="{
      start: '00:00',
      step: '00:15',
      end: '23:45',
      minTime: formInput.start_time,
    }">
          </el-time-select>
        </div>
      </div>
      <div class="form_input flex">
        <label> 原事業單位監工<span class="must">*</span> </label>
        <div>
          <div class="simultaneous">
            <input class="input_primary" v-model="formInput.supervisor" placeholder="姓名" />
            <input class="input_primary" v-model="formInput.phone" placeholder="電話" />
          </div>
        </div>
      </div>

      <!-- <div>div class="form_input flex">
        <label>
          施工人員
          <span class="must">*</span>
        </label>
        <div class="simultaneous">
          <input class="input_primary" v-model="formInput.people" placeholder="姓名" />
        </div>
      </div> -->
      <div class="form_input flex">
        <label>
          作業區域
          <span class="must">*</span>
        </label>
        <div class="multiple_select">
          <el-select v-model="formInput.area_id" filterable allow-create multiple placeholder="請選擇">
            <el-option v-for="item in options.area" :key="item.id" :label="item.location" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="form_input flex" v-if="type && type.includes('enterprise')">
        <label> 施工內容<span class="must">*</span> </label>
        <div>
          <textarea class="input_primary" v-model="formInput.reason"></textarea>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          影響無塵室潔淨度
          <span class="must">*</span>
        </label>
        <div>
          <el-switch v-model="formInput.fab" active-value="1" active-color="#13ce66" inactive-color="#ccc"
            inactive-value="0">
          </el-switch>
        </div>
      </div>
      <div class="form_input flex">
        <label> 影響潔淨度原因</label>
        <div class="form_input_select">
          <el-checkbox-group v-model="formInput.clean">
            <template v-for="(c, i) in clean_option">
              <el-checkbox :label="c.label" :key="i"></el-checkbox>
              <div class="other_input" v-if="c.label == '其他' && formInput.clean.includes('其他')" :key="`${i}_box`">
                <el-input v-model="formInput.clean_other" placeholder="請輸入其他"></el-input>
              </div>
            </template>

          </el-checkbox-group>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          其他環境影響
          <span class="must">*</span>
        </label>
        <div>
          <el-switch v-model="formInput.environment" active-value="1" active-color="#13ce66" inactive-color="#ccc"
            inactive-value="0">
          </el-switch>
        </div>
      </div>
      <div class="form_input flex">
        <label>影響環境類型</label>
        <div class="form_input_select">
          <el-checkbox-group v-model="formInput.environment_list">
            <template v-for="(c, i) in environment_option">
              <el-checkbox :label="c.label" :key="i"></el-checkbox>
              <div class="other_input" v-if="c.label == '其他' && formInput.environment_list.includes('其他')"
                :key="`${i}_box`">
                <el-input v-model="formInput.environment_other" placeholder="請輸入其他"></el-input>
              </div>
            </template>

          </el-checkbox-group>
        </div>
      </div>



      <!-- <div class="form_input flex">
        <label> 安全作業標準 <span class="must">*</span></label>
        <div v-if="!file">
          <button class="btn_primary" @click="link('download/安全作業標準.docx')">
            下載「安全作業標準」文件格式
          </button>
          <label class="upload_UI" :for="'save_upload'">
            <i class="el-icon-plus"></i> 點擊上傳
          </label>
          <input type="file" id="save_upload" name="save_upload" @change="upload($event, 'files')" />
        </div>
        <div class="upload_class" v-else>
          {{ file }}<i @click="cancelUpload" class="el-icon-error"></i>
        </div>
      </div> -->
      <!-- <template v-if="type && type.includes('enterprise')">
        <div class="form_input flex">
          <label> 人員意外險證明 <span class="must">*</span></label>
          <div v-if="!file">
            <label class="upload_UI" :for="'save_upload'">
              <i class="el-icon-plus"></i> 點擊上傳
            </label>
            <input
              type="file"
              id="save_upload"
              name="save_upload"
              @change="upload($evnet, 'files')"
            />
          </div>
          <div class="upload_class" v-else>
            {{ file }}<i @click="cancelUpload" class="el-icon-error"></i>
          </div>
        </div>
        <div class="form_input flex">
          <label> 入廠承諾切結書 <span class="must">*</span></label>
          <div v-if="!file">
            <label class="upload_UI" :for="'save_upload'">
              <i class="el-icon-plus"></i> 點擊上傳
            </label>
            <input
              type="file"
              id="save_upload"
              name="save_upload"
              @change="upload($evnet, 'files')"
            />
          </div>
          <div class="upload_class" v-else>
            {{ file }}<i @click="cancelUpload" class="el-icon-error"></i>
          </div>
        </div>
      </template> -->
    </div>
    <div class="add_notice_btn flex">
      <template v-if="!postLoading">
        <button class="btn_primary" @click="enter">送出</button>
      </template>
      <template v-else>
        <button class="btn_primary" :class="postLoading ? 'disable' : false" :disabled="postLoading">
          處理中<i class="el-icon-loading"></i>
        </button>
      </template>
      <button class="btn_gray" @click="returnLogin">返回</button>
    </div>
  </Div>
</template>
<style lang="scss">
.add_construction .form_input {
  .form_input_select {
    label {
      display: block;

      span {
        color: #ccc;
      }

      &.is-checked {
        span {
          color: #409eff;
        }
      }
    }

    .other_input {
      height: 50px;
    }
  }
}

.width_220 {
  .el-select {
    width: 100%;
  }
}

.construction_id {
  font-size: 12px;
  color: var(--fontGray);
}

.second_contain {
  margin-top: 20px;

  h1 {
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
  }
}

label {
  &.upload_UI {
    margin-top: 10px;
    font-size: 13px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px dashed #ccc;
    display: block;
    text-align: center;
    padding: 10px 50px;
    color: #ccc;

    &:hover {
      border: 1px solid var(--mainColor);
      color: var(--mainColor);

      i {
        color: var(--mainColor);
      }
    }
  }
}

#save_upload {
  display: none;
}

.upload_class {
  i {
    padding: 1px 10px;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }
}

.btn_primary {
  &.disable {
    background: darken(#682dff, 20%);
  }
}

.add_construction {
  .form_input {
    flex-wrap: wrap;
    white-space: nowrap;

    .urgent {
      margin-top: 8px;

      span {
        color: #999;
        font-weight: normal;
      }
    }

    .notice_textarea {
      min-height: 50px;
    }

    .multiple_select {
      .el-select {
        width: 100%;
      }
    }

    .time_range {
      align-items: center;

      // justify-content: space-between;
      i.el-icon-caret-right {
        margin: 0 10px;
      }
    }

    label {
      flex: 2;
      font-weight: bold;

      span {
        color: var(--subColor);
      }
    }

    .simultaneous {
      input {
        display: block;
        margin-bottom: 5px;
      }
    }

    >div {
      flex: 8;

      input,
      textarea {
        width: 100%;
      }
    }

    .special_option {
      max-width: 100%;

      label {
        &.is-checked {
          span {
            color: #409eff;

            font-weight: bold;
          }
        }
      }

      span {
        color: var(--fontGray);
      }

      .el-checkbox-group {
        label {
          display: block;
          font-weight: normal;
        }
      }
    }
  }

  .form_input_box {
    border: 1px solid #dcdfe6;
    width: 100%;
    padding: 20px;
    border-radius: 5px;

    table {
      width: 100%;

      th,
      td {
        padding: 5px;
      }

      th {
        padding: 5px 5px 15px 5px;
        color: #909399;
        font-weight: bold;
        border-bottom: 1px solid #ccc;
      }
    }

    .table_input {
      width: 100%;
      // border: 1px solid #DCDFE6;
      border: none;
      color: #606266;
      background: #efefef;
      border-radius: 4px;
    }
  }

  .file {
    .file_list {
      margin: 5px 0;
      padding: 10px 10px 10px 10px;
      border: 1px dashed #ccc;
      border-radius: 4px;

      p:first-child {
        flex: 3;
      }
    }

    .file_input {
      margin: 20px 0px;

      input {
        display: none;
      }
    }

    .btn_primary,
    .btn_error {
      font-size: 12px;
      cursor: pointer;
      font-weight: normal;
    }
  }

  .add_notice_btn {
    width: 500px;
    margin: 20px auto;

    button {
      margin: 5px;
    }
  }
}

// 隱藏el-date-picker的header中, 年份的前後按鈕
.picker-date {
  .el-date-picker__header {
    button:nth-child(1) {
      display: none;
    }

    button:nth-child(5) {
      display: none;
    }
  }
}
</style>

<script>
import Options from "@/utils/options";
import FactoryVue from "../Factory.vue";
export default {
  name: "add-enterprise-construction",
  data() {
    return {
      formInput: {
        form_id: "",
        employee_id: "",
        application_id: "", //工程編號
        name: "", //工程名稱
        type: "", //作業類別 
        // urgent: false, //是否緊急狀態
        op_id: [], //特殊施工
        date: "", //施工日期
        start_time: "", //開始時間
        end_time: "", //結束時間
        //supervisor_id: "", //承攬商監工
        supervisor: "",
        phone: "",
        //vendor_employees: [], //承攬商施工
        area_id: [], //施工的作業區域
        // safe: [],
        reason: "", //施工項目
        vendor_chinese: [],
        fab: false, //是否有無塵室作業,
        clean: [], //是否影響潔淨度
        clean_other: "",
        environment: false,//是否影響其他環境
        environment_list: [],//項目
        environment_other: "",
        people: "",
        vendor_id: this.$route.query.type ? "" : this.$store.state.user.id,
      },
      formData: new FormData(), //上傳安全作業標準
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time);
        },
      },
      employee_data: "",
      options: {
        // urgent: {
        //   name: "是否為緊急搶修",
        //   value: "urgent",
        //   description: "申請施工開始時間為當日-2日",
        // },
        special: [],
        employee: [],
        development_employee: [],
        entrance_employee: [],
        type: [],
        area: [],
        application: [],
        vendor: [],
      },
      popupStatus: false,
      successText: null,
      popup: null,
      action: {
        index: null,
      },
      innerThead: [
        {
          name: "工作步驟",
          value: "process",
        },
        {
          name: "潛在危害",
          value: "danger",
        },
        {
          name: "安全的工作方法",
          value: "function",
        },
        {
          name: "安全措施",
          value: "measure",
        },
        {
          name: "事故及處理",
          value: "deal",
        },
      ],
      clean_option: [
        {
          label: "掀天花板、掀地板",
          value: "掀天花板、掀地板",
        },
        {
          label: "鑽孔掉屑作業",
          value: "鑽孔掉屑作業",
        },
        {
          label: "移動機台設備、防爆櫃",
          value: "移動機台設備、防爆櫃",
        },
        {
          label: "設備 move in 門開啟時間連續30 min以上",
          value: "設備 move in 門開啟時間連續30 min以上",
        },
        {
          label: "大型機具進入無塵室，例如：堆高機",
          value: "大型機具進入無塵室，例如：堆高機",
        },
        {
          label: "非無塵室使用之物品（任何會發塵的物品），例如：掃把、一般紙",
          value: "非無塵室使用之物品（任何會發塵的物品），例如：掃把、一般紙",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      environment_option: [
        {
          label: "異味",
          value: "異味",
        },
        {
          label: "噪音",
          value: "噪音",
        },
        {
          label: "震動",
          value: "震動",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      file: null,
      postLoading: false,
      formDate: "",
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      if (this.$route.query.type) {
        return this.$route.query.type;
      }
    },
    vendorId_login() {
      return this.$store.state.user.id;
    },
  },
  async created() {
    // if (this.id) {
    //   //填充修改
    //   this.getData();
    // }
    // this.transformFormInput();
    this.options.special = await Options.getSpecialOperation();
    this.options.type = await Options.constructionType();
    // this.getEmployee();
    this.getApplication();
    if (this.type && this.type.includes("enterprise")) {
      const vender_data = await Options.getVendor();
      this.options.vendor = vender_data
        .filter((el) => {
          return el.is_pass == 2;
        })
        .map((el) => {
          return {
            id: el.vendor_id,
            name: el.vendor_chinese,
          };
        });
      this.options.area = await Options.getArea();
      const department_employee = await Options.getDepartmentEmployee();
      this.options.development_employee = department_employee
        .map((el) => {
          return {
            id: el.id,
            name: el.name,
            account: el.account,
          };
        })
        .filter((el) => {
          return el.account;
        });
    }
  },
  methods: {
    transformFormInput() {
      let first = {};
      this.innerThead.forEach((el) => {
        first[el.value] = "";
      });
      this.formInput.safe.push(first);
    },
    dealDisabledDate(time) {
      // 含當天，15天內 卡工程單的結束日期
      //依據type會有不同的限制天數
      //把時間單獨拉出來
      const todayMS = 86400000;
      switch (this.type && this.type.includes("urgent")) {
        case true:
          //disable的條件為範圍為0-2天以內
          return (
            time.getTime() <= Date.now() - todayMS ||
            time.getTime() > Date.now() + todayMS * 2
          );
          break;
        default:
          return (
            time.getTime() <= Date.now() - todayMS ||
            time.getTime() > Date.now() + todayMS * 14 ||
            time.getTime() > new Date(this.formDate)
          );
          break;
      }
    },
    async getEmployee(id) {
      const data = await Options.getVenderEmployee(id);
      this.options.employee = data
        .map((el) => {
          if (el.code_result) {
            return {
              id: el.employee_id,
              name: el.name,
            };
          }
        })
        .filter((el) => {
          return el;
        });
    },
    getOneEmployee(id) {
      if (id) {
        this.$http.api.vendor.vendorEmployeeGet(id).then((res) => {
          this.employee_data = `${res.data.name} / ${res.data.cellphone}`;
        });
      }
    },
    getApplication() {
      this.$http.api.admin
        .getApplication({
          vendor_id: this.type ? "" : this.vendorId_login,
        })
        .then((res) => {
          this.options.application = res.data.filter((el) => {
            const today = this.$moment().format("YYYY-MM-DD");
            const start = this.$moment(new Date(el.start_date))
              .subtract(1, "days")
              .format("YYYY-MM-DD");
            const end = this.$moment(new Date(el.end_date))
              .add(1, "days")
              .format("YYYY-MM-DD");
            if (this.is_role == "manager") {
              return (
                el.status == "同意" &&
                (this.$moment(start).isSameOrAfter(today) ||
                  this.$moment(today).isBetween(start, end))
              );
            } else if (this.is_role == "vendor") {
              return (
                el.status == "同意" &&
                el.vendor_id.includes(this.$store.state.user.id) &&
                (this.$moment(start).isSameOrAfter(today) ||
                  this.$moment(today).isBetween(start, end))
              );
            } else {
              return (
                el.status == "同意" &&
                el.employee.department_id == this.$store.state.user.id &&
                (this.$moment(start).isSameOrAfter(today) ||
                  this.$moment(today).isBetween(start, end))
              );
            }
          });
        });
    },
    getData() {
      this.$http.api.admin.getConstruction(this.id).then((res) => {
        //填充文字
        for (let key in this.formInput) {
          this.formInput[key] = res.data[0][key];
        }
      });
    },
    returnLogin() {
      this.$router.go(-1);
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        this.returnLogin();
      }
    },
    popupAction() {
      const obj = { ...this.formInput }
      //判斷必填
      let must = [
        "reason",
        "date",
        "start_time",
        "end_time",
        "area_id",
        // "people",
        "type",
        "vendor_chinese",
        // "vendor_id",
      ];

      if (this.formInput.type == "特殊作業") {
        must.push("op_id");
      }
      //處理fab清潔度的問題

      if (obj['clean'].includes('其他')) {
        const index = obj['clean'].indexOf('其他')
        obj['clean'][index] = `其他：${obj['clean_other']}`
      }

      obj['clean'] = obj['clean'].join("\n")

      //處理環境
      if (obj['environment_list'].includes('其他')) {
        const index = obj['environment_list'].indexOf('其他')
        obj['environment_list'][index] = `其他：${obj['environment_other']}`
      }

      obj['environment_list'] = obj['environment_list'].join("\n")

      const mustList = this.mustField({
        key: must,
        data: obj,
      });

      // 轉換資料格式
      for (let key in obj) {
        //處理空陣列
        if (
          Array.isArray(obj[key]) &&
          obj[key].length == 0
        ) {
          this.formData.append(`${key}[]`, null);
        }
        //處理有值得陣列
        else if (Array.isArray(obj[key])) {
          //========
          obj[key].forEach((el) => {
            this.formData.append(`${key}[]`, el);
          });
        }
        //其他不是name clean_other的都可以丟進去
        else if (key !== "name" && key !== 'clean_other' && key !== 'environment_other') {
          this.formData.append(key, obj[key]);
        }
      }

      //       else if(!this.file) {
      //   this.popupStatus = true;
      //   this.popup = "error";
      //   this.successText = `請上傳安全作業標準文件`;
      // } 
      if (mustList.length !== 0) {
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫:${mustList.join()}`;
      } else {
        this.postLoading = true;
        console.log(this.formData);
        //判斷是不是緊急單
        this.$http.api.admin
          .postBusineseWork(this.formData)
          .then((res) => {
            console.log(res);
            this.postLoading = false;
            this.popupStatus = true;
            this.successText = "成功";
            this.popup = "success";
          })
          .catch((error) => {
            this.postLoading = false;
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "新增失敗";
          });
      }
    },
    enter() {
      this.popupStatus = true;
      this.successText = "確定送出申請單嗎？送出後不可更改刪除";
      this.popup = "check";
    },
    handlerClear(e) {
      if (!e) {
        this.formInput.start_time = "";
        this.formInput.end_time = "";
      }
    },
    async handlerID(e) {
      this.formInput.form_id = e.form_id;
      this.formInput.application_id = e.id;
      this.formDate = e.end_date;
      const area_data = await Options.getArea();
      this.options.area = area_data.filter((el) => {
        return e.area_id.includes(el.id);
      });
      if (this.type) {
        const vender_data = await Options.getVendor();
        this.options.vendor = vender_data
          .filter((el) => {
            return e.vendor_id.includes(el.vendor_id);
          })
          .map((el) => {
            if (el.is_pass == 2) {
              return {
                id: el.vendor_id,
                name: el.vendor_chinese,
              };
            }
          });
      }
    },
    labelTransfrom({ key, value }) {
      const data = this.options[key].find((el) => {
        console.log('label el:', el);
        return el.value == value;
      });
      if (data) {
        return data.description;
      } else {
        return "";
      }
    },
    // upload(e, file_type) {
    //   this.file = e.target.files[0].name;
    //   this.formData.append("files[]", e.target.files[0]); //放進上傳的檔案
    // },
    // cancelUpload() {
    //   this.file = null;
    //   this.formData.delete("files[]");
    // },
    filterVendorInfo(data) {
      //判斷取消掉得值，是監工有選的
      if (
        (this.formInput.supervisor_id &&
          !data.includes(this.formInput.supervisor_id)) ||
        data.length == 0
      ) {
        this.formInput.supervisor_id = "";
        this.employee_data = "";
      } else {
        this.options.entrance_employee = this.options.employee.filter((el) => {
          return data.includes(el.id);
        });
      }
    },
  },
};
</script>